import { Validation } from "./hook"
import errorText, {ErrorName} from "./error-text"

export function createRegexValidation<T>(fieldName: keyof T, errorName: ErrorName | string, pattern:RegExp, negated: boolean): Validation<T> {
    return (state) => [fieldName, pattern.test(state[fieldName] as string) !== negated && errorText(errorName)]
}

export function createPhoneValidation<T>(fieldName: keyof T): Validation<T> {
    const phonePattern =  /^\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/i
    return createRegexValidation(fieldName, 'VALID_PHONE', phonePattern, true)
}

export function createEmailValidation<T>(fieldName: keyof T): Validation<T> {
    const emailPattern =  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
    return createRegexValidation(fieldName, 'VALID_EMAIL', emailPattern, true)
}

function isEmpty(str:string) { return (!str || 0 === str.length) }

export function createRequiredFieldValidation<T> (fieldName: keyof T): Validation<T> {
    return (state) => [fieldName, isEmpty(state[fieldName] as string) && errorText('REQUIRED_FIELD')]
}

export function createPasswordMatchValidation<T>(passwordField: keyof T, confirmationField: keyof T): Validation<T> {
    return (state) => [passwordField, state[passwordField] !== state[confirmationField] && errorText('PASSWORD_NOT_MATCH')]
}

export function blacklistValidation<T>(fieldName: keyof T, blacklist: Array<string>, errorName: ErrorName | string): Validation<T> {
    return (state) => {
        return [fieldName, (blacklist.length > 0 && blacklist.indexOf(state[fieldName] as string) >= 0) && errorText(errorName)]
    }
}


export function createConditionallyRequiredFieldValidation<T> (fieldName: keyof T, cond: (state:any) => boolean): Validation<T> {
    return (state) => [fieldName, (cond(state) ? isEmpty(state[fieldName] as string) : false) && errorText('REQUIRED_FIELD')]
}


export function createStrongPaswordValidation<T>(passwordField: keyof T): Validation<T> {
    return (state) => {
        const password = typeof(state[passwordField]) == 'string' ? state[passwordField] : ''
        const errors: Array<string> = []
        if (password.length < 8) errors.push('La longitud de la contraseña debe ser igual o mayor a 8 caracteres.');
		if (!/[a-zA-Z]/.test(password) || !/\d/.test(password)) errors.push('La contraseña debe incluir letras y números.');
		if (!/[a-z]/.test(password) || !/[A-Z]/.test(password)) errors.push('La contraseña debe combinar letras mayúsculas y minúsculas.');
		if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) errors.push('La contraseña debe incluir caracteres especiales.');
        return [passwordField, errors.length > 0 && errors]
    }
}